(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function init(root) {
      if (root.__brandsInit) return;
      root.__brandsInit = true;

      var content   = root.querySelector('[data-brands-list]');
      if (!content) return;

      var cards     = Array.prototype.slice.call(content.querySelectorAll('[data-brands-card]'));
      var groups    = Array.prototype.slice.call(content.querySelectorAll('[data-brands-group]'));
      var input     = root.querySelector('[data-brands-search]');
      var clearBtn  = root.querySelector('[data-brands-clear]');
      var searchWrap= root.querySelector('[data-brands-search-wrap]');
      var countEl   = root.querySelector('[data-brands-count]');
      var emptyEl   = root.querySelector('[data-brands-empty]');
      var emptyQEl  = root.querySelector('[data-brands-empty-q]');
      var emptyRst  = root.querySelector('[data-brands-empty-reset]');
      var letterBtns= Array.prototype.slice.call(root.querySelectorAll('[data-brands-letter]'));

      var total = cards.length;
      var initialGroupCounts = {};
      groups.forEach(function (g) {
        initialGroupCounts[g.getAttribute('data-brands-group')] =
          g.querySelectorAll('[data-brands-card]').length;
      });

      var state = { query: '' };
      var debounce;

      function pluralize(n, one, many) {
        return n === 1 ? one : many;
      }

      function apply() {
        var q = state.query.trim().toLowerCase();
        var visible = 0;
        var perGroup = {};

        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var name = c.getAttribute('data-name') || '';
          var initial = c.getAttribute('data-initial') || '';
          var show = !q || name.indexOf(q) !== -1;
          if (show) {
            c.removeAttribute('hidden');
            visible++;
            perGroup[initial] = (perGroup[initial] || 0) + 1;
          } else {
            c.setAttribute('hidden', '');
          }
        }

        groups.forEach(function (g) {
          var letter = g.getAttribute('data-brands-group');
          var n = perGroup[letter] || 0;
          g.toggleAttribute('hidden', n === 0);
          var cEl = g.querySelector('[data-brands-group-count]');
          if (cEl) {
            if (q) {
              cEl.innerHTML = '<b>' + n + '</b>of ' + initialGroupCounts[letter];
            } else {
              cEl.innerHTML = '<b>' + initialGroupCounts[letter] + '</b>' +
                              pluralize(initialGroupCounts[letter], 'brand', 'brands');
            }
          }
        });

        letterBtns.forEach(function (b) {
          var letter = b.getAttribute('data-brands-letter');
          var has = (perGroup[letter] || 0) > 0;
          var hadOriginally = (initialGroupCounts[letter] || 0) > 0;
          if (!hadOriginally || !has) {
            b.setAttribute('disabled', '');
            b.setAttribute('aria-disabled', 'true');
          } else {
            b.removeAttribute('disabled');
            b.removeAttribute('aria-disabled');
          }
        });

        if (countEl) {
          if (!q) {
            countEl.innerHTML = '<b>' + total + '</b>' + pluralize(total, 'result', 'results');
          } else {
            countEl.innerHTML = '<b>' + visible + '</b>of ' + total;
          }
        }

        if (emptyEl) {
          if (visible === 0) {
            emptyEl.removeAttribute('hidden');
            if (emptyQEl) emptyQEl.textContent = q ? '\u201C' + q + '\u201D' : 'your search';
          } else {
            emptyEl.setAttribute('hidden', '');
          }
        }

        if (searchWrap) {
          searchWrap.classList.toggle('is-active', state.query.length > 0);
        }
      }

      function scrollToLetter(letter) {
        var target = groups.filter(function (g) {
          return g.getAttribute('data-brands-group') === letter;
        })[0];
        if (!target || target.hasAttribute('hidden')) {
          if (input && state.query) {
            state.query = '';
            input.value = '';
            apply();
            requestAnimationFrame(function () { scrollToLetter(letter); });
          }
          return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function setActiveLetter(letter) {
        letterBtns.forEach(function (b) {
          var match = b.getAttribute('data-brands-letter') === letter;
          b.setAttribute('aria-current', match ? 'true' : 'false');
        });
      }

      if (input) {
        input.addEventListener('input', function (e) {
          clearTimeout(debounce);
          var v = e.target.value;
          debounce = setTimeout(function () {
            state.query = v;
            apply();
          }, 60);
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && input.value) {
            input.value = '';
            state.query = '';
            apply();
            e.stopPropagation();
          }
        });
      }

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          if (input) { input.value = ''; input.focus(); }
          state.query = '';
          apply();
        });
      }

      if (emptyRst) {
        emptyRst.addEventListener('click', function () {
          if (input) { input.value = ''; input.focus(); }
          state.query = '';
          apply();
        });
      }

      letterBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.hasAttribute('disabled')) return;
          var letter = b.getAttribute('data-brands-letter');
          setActiveLetter(letter);
          scrollToLetter(letter);
        });
      });

      if ('IntersectionObserver' in window && groups.length) {
        var stickyTopPx = parseInt(
          getComputedStyle(root).getPropertyValue('--bd-sticky-top'), 10
        ) || 80;
        var obs = new IntersectionObserver(function (entries) {
          var visibleNow = entries
            .filter(function (e) { return e.isIntersecting; })
            .map(function (e) { return e.target; });
          if (!visibleNow.length) return;
          visibleNow.sort(function (a, b) {
            return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
          });
          var top = visibleNow[0];
          if (top && !top.hasAttribute('hidden')) {
            setActiveLetter(top.getAttribute('data-brands-group'));
          }
        }, {
          rootMargin: '-' + stickyTopPx + 'px 0px -70% 0px',
          threshold: 0
        });
        groups.forEach(function (g) { obs.observe(g); });
      }

      apply();
    }

    function boot() {
      document.querySelectorAll('[class*="brands-dir-"]').forEach(init);
      document.addEventListener('keydown', function (e) {
        if (e.key !== '/') return;
        var ae = document.activeElement;
        if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) return;
        var first = document.querySelector('[data-brands-search]');
        if (first) {
          e.preventDefault();
          first.focus();
          first.select && first.select();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelectorAll) {
        e.target.querySelectorAll('[class*="brands-dir-"]').forEach(init);
      }
    });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
